module.exports = __webpack_public_path__ + "static/img/icon8.497ff3ef.svg";